import { FetchOptions, FetchResponse } from '../../../ReplicantAPI';
import { Fetcher } from '../Fetcher';

export class ReplicantBrowserFetcher implements Fetcher {
    async fetch(options: FetchOptions): Promise<FetchResponse> {
        const response = await fetch(options.url, {
            method: options.method,
            headers: options.headers,
            body: options.method === 'POST' ? options.body : null,
        });

        const text = await response.text();

        const headers: { [key: string]: string } = {};
        response.headers.forEach((val, key) => (headers[key] = val));

        return {
            body: text,
            headers,
            statusCode: response.status,
            url: options.url,
        };
    }
}
